import { getCountryCodesAction } from "../../../../Actions/LogicActions/MyAccount/PersonalInformation/GetCountryCodesAction";
import { initializeFormAction } from "../../../../Actions/LogicActions/MyAccount/PersonalInformation/InitializeFormAction";
import { phoneNumberOtpVerifyAction } from "../../../../Actions/LogicActions/MyAccount/PersonalInformation/PhoneNumberOtpVerifyAction";
import { phoneNumberVerifyAction } from "../../../../Actions/LogicActions/MyAccount/PersonalInformation/PhoneNumberVerifyAction";
import { savePersonalInfoAction } from "../../../../Actions/LogicActions/MyAccount/PersonalInformation/SavePersonalInfoAction";
import { setFormValidAction } from "../../../../Actions/LogicActions/MyAccount/PersonalInformation/SetFormValidAction";
import { setPersonalInfoModifiedAction } from "../../../../Actions/LogicActions/MyAccount/PersonalInformation/SetPersonalInfoModifiedAction";
import { resetOtpModalStateAction } from "../../../../Actions/UIActions/MyAccount/PersonalInformation/ResetOtpModalStateAction";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { myAccountTree } from "../../../../Orchestrator/ConstantTree";
import { PersonalInformationContext } from "../Context/PersonalInformationContext";

export class PersonalInformationInitStep extends StepFlow {
    get stepName() { return "PersonalInformationInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.PersonalInformation.MobileCountryCode.Click,
                handler: async () => {
                    await getCountryCodesAction.execute();
                    if (getCountryCodesAction.result) {
                        let context = this.getCtx<PersonalInformationContext>("personalInformationContext");
                        if (context) {
                            context.countryCodes = getCountryCodesAction.result;
                        }
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.PersonalInformation.Form.Modified,
                handler: (data: any) => {
                    let context = this.getCtx<PersonalInformationContext>("personalInformationContext");
                    if (context) {
                        context.isFormModified = data.data!;
                    }
                    setPersonalInfoModifiedAction.setParams(data.data!);
                    setPersonalInfoModifiedAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.PersonalInformation.Form.Validation,
                handler: (data: any) => {
                    let context = this.getCtx<PersonalInformationContext>("personalInformationContext");
                    if (context) {
                        context.isFormValid = data.data!;
                    }
                    setFormValidAction.setParams(data.data!);
                    setFormValidAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.PersonalInformation.Form.Initialize,
                handler: (data: any) => {
                    let context = this.getCtx<PersonalInformationContext>("personalInformationContext");
                    if (context) {
                        context.formData = data.data!;
                    }
                    initializeFormAction.setParams(data.data!);
                    initializeFormAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.PersonalInformation.Form.Save,
                handler: (data: any) => {
                    savePersonalInfoAction.setParams(data.data!);
                    savePersonalInfoAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.PersonalInformation.OTP.Verify.Click,
                handler: async (data: any) => {
                    phoneNumberVerifyAction.setParams(data.data!);
                    await phoneNumberVerifyAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.PersonalInformation.OTP.Verify.SendCode,
                handler: async (data: any) => {
                    phoneNumberOtpVerifyAction.setParams(data.data!);
                    await phoneNumberOtpVerifyAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.PersonalInformation.OTP.Reset,
                handler: async (data: any) => {
                    await resetOtpModalStateAction.execute();
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: myAccountTree.exitStep,
                handler: () => {
                    this.next();
                }
            })
        )

    }

    async onExecute(): Promise<void> {
        console.log("Personal Information Page Initialize.....")

        _eventBus.emit({
            eventName: myAccountTree.PersonalInformation.MobileCountryCode.Click
        });
    }
}

export const PersonalInfoInitStepDeclaration = new StepDefinition({
    stepName: "PersonalInformationInit_Step",
    stepClass: PersonalInformationInitStep
});